import styled from 'styled-components'

export const I18nPageWrapper = styled.div`
`

